import { getFlatTourBookingInfo } from './getFlatTourBookingInfo';
import { IAppState } from '../../common/state';
import { EBookingStatusType } from '../../types/newbuildingHeader';

export function getButtonText(state: IAppState): string | null {
  const flatTourBookingInfo = getFlatTourBookingInfo(state);

  if (flatTourBookingInfo) {
    const { orderStatus } = flatTourBookingInfo;
    const { type } = orderStatus;

    if (type === EBookingStatusType.SignedUp) {
      return 'Вы записаны на просмотр';
    }

    if (type === EBookingStatusType.NoActive) {
      return 'Записаться на просмотр';
    }
  }

  return null;
}
